module.exports = __webpack_public_path__ + "static/media/video.3d4bf91.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video.mp4
// module id = q3HI
// module chunks = 1